var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":_vm.width},model:{value:(_vm.opened),callback:function ($$v) {_vm.opened=$$v},expression:"opened"}},[_c(_vm.component,_vm._b({tag:"component",on:{"close":_vm.close}},'component',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }